
import { APP_INITIALIZER, Inject, Renderer2, importProvidersFrom, inject, isDevMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppComponent } from '@app/app.component';
import { RouterModule } from '@angular/router';
import { routes } from '@app/app-routing.module';
import { Store, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ToastrModule } from 'ngx-toastr';
import { MAT_RIPPLE_GLOBAL_OPTIONS, RippleGlobalOptions } from '@angular/material/core';

import { WSEffects } from '@app/store/features/web-socket/web-socket.effects';
import { ConfigEffects } from '@app/store/features/config/config.effects';
import { AuthService } from '@app/features/auth/services/auth.service';


import { ActionReducerMap } from "@ngrx/store";
import * as WebSocket from '@app/store/features/web-socket/web-socket.reducer';
import * as Config from '@app/store/features/config/config.reducer';
import * as ConfigActions from '@app/store/features/config/config.actions';

import * as Auth from '@app/store/features/auth/auth.reducer';
import { AuthEffects } from '@app/store/features/auth/auth.effects';
import { DOCUMENT } from '@angular/common';
import { ThemeService } from '@app/services/theme.service';
import { Observable, combineLatest, lastValueFrom, take, tap } from 'rxjs';
import { provideToastr } from 'ngx-toastr';
import { ConfigService } from '@app/services/config.service';
import { WINDOW_PROVIDERS } from '@app/services/window.providers';
import { DialogModule } from '@angular/cdk/dialog';
import { provideAngularSvgIcon } from 'angular-svg-icon';

import { TranslateModule } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideServiceWorker } from '@angular/service-worker';
import { environment } from '@environments/environment';

import { metaReducers } from '@app/store/meta-reducers';
import { MainState } from '@app/store/features/main/main.reducers';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

export interface State {
  ws: WebSocket.State;
  config: Config.State;
  auth: Auth.State;
  main?: MainState;
}

export const reducers: ActionReducerMap<State> = {
  ws: WebSocket.reducer,
  config: Config.reducer,
  auth: Auth.reducer,

}



function initializeAppFactory(themeService: ThemeService, configService: ConfigService, store: Store<any>): () => Observable<any> {
  return () => combineLatest([themeService.applyTheme(), configService.loadConfig()])
    .pipe(
      tap(([theme, domainSettings]) => store.dispatch(ConfigActions.updateDomainSettings({ domainSettings }))),






      tap(([theme, domainSettings]) => {
        // ✅ Helper to create and append meta tags
        function addMeta(name: string, content: string): void {
          const meta = document.createElement('meta');
          meta.setAttribute('name', name);
          meta.setAttribute('content', content);
          document.head.appendChild(meta);
        }

        // ✅ 1. Add iOS PWA-specific meta tags
        addMeta('apple-mobile-web-app-capable', 'yes');
        addMeta('apple-mobile-web-app-status-bar-style', 'black-translucent');
        addMeta('apple-mobile-web-app-title', 'TEST poker-game2'); // Adjust dynamically if needed

        // ✅ 2. Create and append <link rel="icon">
        const iconEl = document.createElement('link');
        iconEl.setAttribute('rel', 'icon');
        iconEl.setAttribute('type', 'image/png');
        iconEl.setAttribute(
          'href',
          `${environment.dataSource}/assets/${domainSettings.code}/fav-launcher-icons/favicon-16x16.png`
        );
        document.head.appendChild(iconEl);

        // ✅ 3. Create and append <link rel="manifest"> dynamically
        const manifest = {
          name: "TEST poker-game2",
          short_name: "TEST poker-game2",
          theme_color: "#ff0000",
          background_color: "#fafafa",
          display: "standalone",
          scope: "./",
          start_url: "./",
          icons: [
            {
              src: `${environment.dataSource}/assets/${domainSettings.code}/fav-launcher-icons/apple-icon-72x72.png`,
              sizes: "72x72",
              type: "image/png"
            },
            {
              src: `${environment.dataSource}/assets/${domainSettings.code}/fav-launcher-icons/favicon-96x96.png`,
              sizes: "96x96",
              type: "image/png"
            },
            {
              src: `${environment.dataSource}/assets/${domainSettings.code}/fav-launcher-icons/ms-icon-144x144.png`,
              sizes: "144x144",
              type: "image/png"
            },
            {
              src: `${environment.dataSource}/assets/${domainSettings.code}/fav-launcher-icons/apple-icon-152x152.png`,
              sizes: "152x152",
              type: "image/png"
            },
            {
              src: `${environment.dataSource}/assets/${domainSettings.code}/fav-launcher-icons/android-icon-192x192.png`,
              sizes: "192x192",
              type: "image/png"
            }
            // Additional sizes (384x384, 512x512) can be added here if needed
          ]
        };

        // CODE_DEBT: Consider moving manifest generation to server-side in the future
        const stringManifest = JSON.stringify(manifest);
        const blob = new Blob([stringManifest], { type: "application/json" });
        const manifestURL = URL.createObjectURL(blob);

        const manifestEl = document.createElement("link");
        manifestEl.setAttribute("rel", "manifest");
        manifestEl.setAttribute("href", manifestURL);
        document.head.appendChild(manifestEl);



      }),

      take(1)
    );
}

bootstrapApplication(AppComponent, {
  providers: [
    WINDOW_PROVIDERS,
    importProvidersFrom(
      RouterModule.forRoot(routes, { useHash: true }),
      StoreModule.forRoot(reducers, { metaReducers }),
      EffectsModule.forRoot([
        ConfigEffects,
        WSEffects,
        AuthEffects,
      ]), DialogModule, TranslateModule.forRoot({
        defaultLanguage: 'en',
      }),
      StoreDevtoolsModule.instrument({
        name: 'Poker Game 2',
        maxAge: 50,
        logOnly: !!environment.useReduxDevTools,     // restrict in prod
        trace: true,
        traceLimit: 25,
        serialize: false,          // set true only if you need to handle non-serializables
      })
    ),
    provideAnimations(),
    provideHttpClient(),
    provideToastr({
      timeOut: 60000,
      preventDuplicates: true,
      progressBar: true,
      progressAnimation: 'increasing',
      tapToDismiss: false,
      enableHtml: true,
      closeButton: true
    }),
    provideAngularSvgIcon(),
    provideTranslateHttpLoader({ prefix: './assets/i18n/', suffix: '.json' }),
    { provide: APP_INITIALIZER, useFactory: initializeAppFactory, deps: [ThemeService, ConfigService, Store], multi: true },
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),

  ]
}).then(appRef => {
  // 🔍 MEMORY DEBUGGING: Expose store for console debugging in dev mode
  if (isDevMode() || environment.devMode) {
    const store = appRef.injector.get(Store);
    let currentState: any;
    store.subscribe(state => currentState = state);
    
    (window as any).__ngxStore__ = {
      getValue: () => currentState
    };
    
    console.log('🔍 Dev Mode: NgRx store exposed for memory debugging');
    console.log('   Access via: window.__ngxStore__.getValue()');
  }
}).catch(err => console.error(err));